<template>
    <div id="tinder-c">
      <div v-if="displayLogin">
        <user-form :userId.sync="userId"></user-form>
      </div>
      <div v-if="crushPendingImages > 0 && !displayLogin">
        <p class="h3 text-center title-1"> {{brandName}}</p>
        <p class="h5 text-center title-2"> Like or not like?</p>                         
        <Tinder ref="tinder" key-name="url" :queue.sync="queue" :offset-y="10" @submit="onSubmit">
        <template slot-scope="scope">
            <div
            class="pic"
            :style="{
                'background-image': `url(${scope.data.url})` 
            }"
            />
        </template>
        </Tinder>
        <div class="btns">
             <v-btn
              icon
              @click="decide('nope')"
              class="mr-5"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>            
            <v-btn
              icon
              @click="decide('like')"
              class="ml-5"
            >
              <v-icon> mdi-heart</v-icon>
            </v-btn>
          </div>
      </div>
      <div v-if="crushPendingImages == 0 && likes.length > 0 && !displayLogin">        
        <div class="h5 text-center title"> Choose your favorite look </div> 
        <div class="vue-tinder text-center oo">          
          <div v-if="leftIndex != -1" class="tinder-card-oo" v-on:click="oo('left')" style="z-index: 100; transform: translate3d(0px, 0px, 0px) rotate(0deg); transition: none 0s ease 0s;">
            <div class="pic" :style="leftBgImage"></div>
          </div>
          <div v-if="rightIndex != -1" class="tinder-card-oo" v-on:click="oo('right')" style="z-index: 100; transform: translate3d(0px, 0px, 0px) rotate(0deg); transition: none 0s ease 0s;">
            <div class="pic" :style="rightBgImage"></div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import Tinder from "vue-tinder"
  import UserForm from './user-form.vue'
  import * as Api from '../tools/api'

  export default {
    name: 'tinder-swipper',
    props:['interaction','brand_id'],
    components:{ Tinder, UserForm },
    data: () => ({
      show: false,
      userId: -1,
      activeIndex: 0,
      queue: [],
      offset: 0,
      history: [],
      crushPendingImages:0,
      likes: [],
      leftIndex: 0,
      rightIndex:1,
      remoteData:{},
      finish: false,
      brandName: ''
    }),
    created() {
    },
    async mounted(){
      console.log(`Param interaction is ${this.interaction} -- ${this.brand_id}`)
        let response = await Api.getData(this.interaction, this.brand_id)
        this.remoteData = JSON.parse(response.interactions_actions_by_pk.action)
        this.brandName = response.brands_by_pk.name
        this.crushPendingImages = this.elements.length
        this.mock();
        // console.log(`Param interaction is ${this.interaction}`)
        // console.log("XXX", JSON.parse(response.interactions_actions_by_pk.action))
    },
    methods:{
        mock(count = 2, append = true) {
            const list = [];
            for (let i = 0; i < count; i++) {
                if (this.offset < this.elements.length){
                    list.push(this.elements[this.offset]);
                    this.offset++;
                }
            }
            if (append) {
                this.queue = this.queue.concat(list);
            } else {
                this.queue.unshift(...list);
            }
        },
        onSubmit({ item, type  }) {
            if (this.queue.length < 3) {
                this.mock();
            }
            this.history.push(item);
            this.crushPendingImages--
            if(type == 'like')
              this.likes.push(item)

            this.sendCrushResult(type,item)
            //console.log(`Send results: ${type} - ${item} - ${this.crushPendingImages}`)
        },
        decide(choice) {        
           this.$refs.tinder.decide(choice);              
        },
        async sendCrushResult(type, item){
          let result = {}
          // console.log(`Send results: ${type} - ${item} - ${this.crushPendingImages}`)
          result.brand_id = item.brandId
          result.image_url = item.url
          result.product_id = item.id
          result.user_id = this.userId
          result.like = type == "like" ? true:false
          result.question_id = this.questionId
          // console.log(result)
          Api.sendCrushData(result)
        },
        async sendOOResult(item){
          let result = {}
          console.log(item)
          // console.log(`Send results: ${type} - ${item} - ${this.crushPendingImages}`)
          result.brand_id = item.brandId
          result.image_url = item.url
          result.product_id = item.id
          result.user_id = this.userId
          result.question_id = this.questionId
          // console.log(result)
          Api.sendOOData(result)
        },
        oo(side){
          let nextIndex = Math.max(this.leftIndex,this.rightIndex) + 1
          let item = {}
          if (nextIndex < this.likes.length && !this.finish){
            if (side == 'right')
              this.leftIndex = nextIndex
            else
              this.rightIndex = nextIndex
          }else{
            side == 'right' ? this.leftIndex = -1 : this.rightIndex = -1  
            if(this.leftIndex > -1 && !this.finish){
              item = this.likes[this.leftIndex]
              this.sendOOResult(item)
              this.finish = true
            }else if(this.rightIndex > -1 && !this.finish){
              item = this.likes[this.rightIndex]
              this.sendOOResult(item)
              this.finish = true
            }
          }
        }
    },
    computed:{
      crushData(){
        if (Object.keys(this.remoteData).length >0)
          return this.remoteData
        else
          return JSON.parse('{ "actionId": "act_52p3Rof3y", "attributes": { "vibration": true, "screenOrientation": "PORTRAIT", "sound": "notif_6.mp3" }, "modifiers": { "clear": "KEEP_MULTIMEDIA" }, "type": "crush", "questionId": "", "elements": [], "title": { "es": "¿Te gustan estos vestidos?", "en": "Do you like these dresses?" }, "placeHolderImage": "https://bridal-assets.s3.amazonaws.com/documents/kalliope2022/push/logoNeg.png" }')
      },
      displayLogin(){        
        if(this.userId > 0)
          return false
        else
          return true
      },
      elements(){
          return this.crushData.elements
      },
      questionId(){
        return this.crushData.questionId
      },
      leftBgImage(){
        return {
          "background-image": `url(${this.likes[this.leftIndex].url})`
        }
      },
      rightBgImage(){
        return {
          "background-image": `url(${this.likes[this.rightIndex].url})`
        }
      },
    }
  }
</script>

<style>
html,
body {
  height: 100%;
}

body {
  margin: 0;
  background-color: #20262e;
  overflow: hidden;
}

#app .vue-tinder {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 23px;
  margin: auto;
  width: calc(100% - 20px);
  height: calc(100% - 23px - 47px - 16px);
  min-width: 300px;
  max-width: 355px;
}
oo {
  position: relative;
}
.title-1 {
  position: absolute;
  top: 60px;
  right: 0;
  left: 0;
  bottom: 0;  
  margin: auto;
}
.title-2 {
  position: absolute;
  top: 80px;
  right: 0;
  left: 0;
  bottom: 0;  
  margin: auto;
}

.tinder-card, .vue-tinder.oo{
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    height: 70% !important;
    margin: auto;
}
.tinder-card-oo {
  position: relative;
  display: inline-flex;
  margin: 1%;
  width: 45%;
  height: 70%;
  overflow: hidden;
  background: #fefefe;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}


.pic {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.btns {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100px;
  margin: auto;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 300px;
  max-width: 355px;
  z-index: 1000;
}

.btns img {
  margin-right: 12px;
  box-shadow: 0 4px 9px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.btns img:nth-child(2n + 1) {
  width: 53px;
}

.btns img:nth-child(2n) {
  width: 65px;
}

.btns img:nth-last-child(1) {
  margin-right: 0;
}


/* .nope-pointer,
.like-pointer {
  position: absolute;
  z-index: 1;
  top: 20px;
  width: 64px;
  height: 64px;
} */


/* .nope-pointer {
  right: 10px;
}

.like-pointer {
  left: 10px;
} */

/* .super-pointer {
  position: absolute;
  z-index: 1;
  bottom: 80px;
  left: 0;
  right: 0;
  margin: auto;
  width: 112px;
  height: 78px;
}

.rewind-pointer {
  position: absolute;
  z-index: 1;
  top: 20px;
  right: 10px;
  width: 112px;
  height: 78px;
} */

</style>

